import React from 'react';
import ExchangeService from './../../../service/exchange';
import { FORM_FIELD } from './../core/abstract';
import ValidateService from './../../../service/validate';
import mapStateToProps from './../../../store/map/auth-token';
import mapDispatchToProps from './../../../store/map/on-logout';
import { connect } from 'react-redux';
import SearchPrompt from './../core/search';
import ExchangeSearchActiveViewPrompt from './view';
import { ExchangeSearchActiveSingleFieldPromptContainer } from './view';
import theme from './../../theme';

class _ExchangeSearchActivePrompt extends SearchPrompt 
{
    constructor(parms)
    {
        super(parms, _ExchangeSearchActivePrompt.getValidators());

        this.getFieldsModel = this.getFieldsModel.bind(this);
        this.getDefaultState = this.getDefaultState.bind(this);
        this.onSearchResponse = this.onSearchResponse.bind(this);
        this.onSearchError = this.onSearchError.bind(this);
        this.onSendToServer = this.onSendToServer.bind(this);
        this.getServerRequest = this.getServerRequest.bind(this);
        this.getConfirmUi = this.getConfirmUi.bind(this);
        this.getBaseStateOnResponse = this.getBaseStateOnResponse.bind(this);
        this.getSearchResultsUi = this.getSearchResultsUi.bind(this);
        this.getSearchResultUi = this.getSearchResultUi.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
        this.onLoadSpecifiedPage = this.onLoadSpecifiedPage.bind(this);
        this.pageToUrl = this.pageToUrl.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.getSingleFieldPrompt = this.getSingleFieldPrompt.bind(this);
    }

    static getValidators()
    {
        return {
            title: {
                isValid: ValidateService.textLine,
            },
        };
    }

    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    getFieldsModel()
    {
        return {
            title: {
                name: 'Search',
                error: 'no more than 112 characters',
                value: '',
                visible: true,
                valid: true,
                touched: false,
                type: FORM_FIELD.TEXT,
            },
        };
    }

    /* istanbul ignore next */
    componentDidUpdate(prevProps, prevState)
    {
        if(this.props.page !== prevProps.page)
        {
            this.setContactingServer(true);
            this.onSendToServer({
                title: this.props.searchText ? this.props.searchText : '',
                page: this.props.page ? this.props.page : 0,
            });
        }
    }

    onSearchResponse(response)
    {
        super.onSearchResponse(response, 'exchangeList');
    }

    onSendToServer(request = undefined)
    {
        ExchangeService.searchActive({
            request: request ? request : this.getServerRequest(),
            onResponse: this.onSearchResponse,
            onError: this.onSearchError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    /* istanbul ignore next */
    getServerRequest()
    {
        return {
            title: this.state.title.value,
            page: this.props.page ? this.props.page : 0,
        };
    }

    /* istanbul ignore next */
    onLoadSpecifiedPage(page)
    {
        this.setContactingServer(true);
        let request = this.getServerRequest();
        request.page = page;
        ExchangeService.searchActive({
            request,
            onResponse: this.onSearchResponse,
            onError: this.onSearchError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    pageToUrl(page)
    {
        const loadPageUrl = `/exchanges/active/${page}/${encodeURI(this.state.title.value)}`;
        return loadPageUrl;
    }

    getSearchResultUi(aResult, index)
    {
        return <ExchangeSearchActiveViewPrompt exchange={aResult} key={index} />
    }

    getSingleFieldPrompt()
    {
        return (
            <ExchangeSearchActiveSingleFieldPromptContainer>
                <form onSubmit={this.onFormSubmit} style={{
                            ...theme.getOfferSearchSingleFormContainerStyle(theme),
                        }}>
                        { this.getServerFeedbackUi() }
                        <div style={{
                            ...theme.getInLineTextStyle(theme),
                        }}>
                            <div style={{
                                ...theme.getOfferSearchSingleFormStyle(theme),
                            }}>
                                { this.getFormFieldsUi() }
                            </div>

                            <div>
                                { this.getSubmitButtonUi() }
                            </div>
                        </div>
                    </form>
            </ExchangeSearchActiveSingleFieldPromptContainer>
        );
    }
}

const ExchangeSearchActivePrompt = connect(mapStateToProps, mapDispatchToProps)(_ExchangeSearchActivePrompt);
export default ExchangeSearchActivePrompt;
